module.exports = __webpack_public_path__ + "static/a-titan-steps-into-a-galaxy-far-far-away-478b77fe1e8461a3d5a07b408e25bb9f.jpg";